import * as React from "react";
import { cn } from "@/lib/utils";

type AttendanceStatus = "PRESENT" | "ABSENT" | "LATE";

interface AttendanceToggleProps {
  enrollmentId: string;
  studentName: string;
  current: AttendanceStatus | null;
  onChange: (status: AttendanceStatus) => void;
  disabled?: boolean;
}

const STATUSES: { value: AttendanceStatus; label: string }[] = [
  { value: "PRESENT", label: "Present" },
  { value: "LATE", label: "Late" },
  { value: "ABSENT", label: "Absent" },
];

export function AttendanceToggle({
  enrollmentId,
  studentName,
  current,
  onChange,
  disabled = false,
}: AttendanceToggleProps) {
  return (
    <div
      data-testid={`attendance-${enrollmentId}`}
      className="flex gap-1"
      role="group"
      aria-label={`Attendance for ${studentName}`}
    >
      {STATUSES.map(({ value, label }) => {
        const isActive = current === value;
        return (
          <button
            key={value}
            type="button"
            aria-label={`${studentName} ${label}`}
            aria-pressed={isActive}
            disabled={disabled}
            onClick={() => onChange(value)}
            className={cn(
              "min-w-[44px] min-h-[44px] cursor-pointer transition-colors duration-150 text-xs font-semibold rounded px-2",
              isActive && value === "PRESENT" && "bg-emerald-600 text-white",
              isActive && value === "LATE" && "bg-amber-500 text-white",
              isActive && value === "ABSENT" && "bg-rose-600 text-white",
              !isActive && "bg-slate-100 text-slate-700 hover:bg-slate-200",
              "focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:outline-none"
            )}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
